import { render, staticRenderFns } from "./SegmentOverview.vue?vue&type=template&id=640285a4&scoped=true&"
import script from "./SegmentOverview.vue?vue&type=script&lang=js&"
export * from "./SegmentOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640285a4",
  null
  
)

export default component.exports